var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTabPhRecommendationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 9.6,
  height: 12.5,
  x: 5.2,
  y: 4,
  fill: "none",
  rx: 1.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M8 4.2v-1h4v1M7.6 9h4.8m-4.8 3h4.8"
})));
export default SvgTabPhRecommendationIcon;